/**
 * StatusBadge Component
 *
 * Visual badge for displaying request status with color coding
 */

import React from 'react';
import { LeadRequestStatus } from 'types/leadRequestsTypes';
import * as S from './styles';

interface StatusBadgeProps {
  status: LeadRequestStatus | string;
  size?: 'small' | 'medium';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'medium' }) => {
  const getStatusColor = (status: string): string => {
    switch (status) {
      case LeadRequestStatus.NEW:
        return '#4A90E2'; // Blue
      case LeadRequestStatus.REQUESTED:
        return '#F5A623'; // Yellow/Orange
      case LeadRequestStatus.ACCEPTED:
        return '#7ED321'; // Green
      case LeadRequestStatus.REJECTED:
        return '#D0021B'; // Red
      case LeadRequestStatus.CANCELED:
        return '#9B9B9B'; // Gray
      default:
        return '#9B9B9B';
    }
  };

  const getStatusLabel = (status: string): string => {
    const labels: Record<string, string> = {
      [LeadRequestStatus.NEW]: 'Novo',
      [LeadRequestStatus.REQUESTED]: 'Solicitado',
      [LeadRequestStatus.ACCEPTED]: 'Aceito',
      [LeadRequestStatus.REJECTED]: 'Rejeitado',
      [LeadRequestStatus.CANCELED]: 'Cancelado',
    };
    return labels[status] || status.charAt(0) + status.slice(1).toLowerCase();
  };

  return (
    <S.StatusBadge color={getStatusColor(status)} size={size}>
      {getStatusLabel(status)}
    </S.StatusBadge>
  );
};

export default StatusBadge;
